import React      from 'react';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import TrainingTypeIcon from '../TrainingTypeIcon';
import ButtonLink from '../ButtonLink';
import nav from '../../services/navigator'

import style from './style.scss';
import * as marketingAdActions from "../../actions/marketingAd";

class MarketingAdvert extends React.Component {
    componentDidMount() {
        this.props.getAd();
    }

    _navigateToCourse(e, url) {
        e.preventDefault();
        nav.push(url);
    }
    _navigateToElearning(e) {
        e.preventDefault();
        nav.push('/courses');
    }
    render() {

        const {marketingAd, isLoading} = this.props;

        if (isLoading || !marketingAd.is_visible) {
            return null;
        }

        return (
            <div className={style['container']} style={{backgroundColor: this.props.backgroundColor}}>
                <div className={style['content']}>
                    <a href="/courses" onClick={this._navigateToElearning}>
                        <TrainingTypeIcon className={style['icon']} type={marketingAd.icon} backgroundColour="#000000"/>
                    </a>
                    <a className={style['title-container']} href="courses" onClick={this._navigateToElearning}>
                        <h2 className={style['title']}>{marketingAd.icon}</h2>
                    </a>
                    <div className={style['info']}>
                        <span>{marketingAd.title}</span><br/>
                        <a className={style['info__link']} href={marketingAd.url} onClick={e => this._navigateToCourse(e, marketingAd.url)}>
                            <strong>{marketingAd.sub_title}</strong>
                        </a>
                        <br/>
                        <span>{marketingAd.description}</span>
                    </div>
                    <ButtonLink
                        to={marketingAd.url}
                        style={{backgroundColor: '#000000'}}>
                        Details
                    </ButtonLink>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        marketingAd: state.marketingAd.ad,
        isLoading: state.marketingAd.loading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAd: () => dispatch(marketingAdActions.getAd())
    }
}

export default CSSModules(connect(mapStateToProps, mapDispatchToProps)(MarketingAdvert), style);


// WEBPACK FOOTER //
// ./components/MarketingAdvert/index.js